(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    const scrollToCard = () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) card.scrollIntoView({ behavior: 'instant' });
    };
    // {% javascript %} is injected as a deferred script — DOMContentLoaded has already fired
    // by the time this runs, so a plain addEventListener would never call the handler.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scrollToCard, { once: true });
    } else {
      scrollToCard();
    }
  }

  // Relocates the filters' horizontal controls bar (sort / grid density / product count) out of
  // the left category sidebar and above the product grid. Re-applied via MutationObserver
  // because the section morphs (and re-inserts the bar into the sidebar) on every sort/filter.
  if (!customElements.get('collection-layout')) {
    customElements.define(
      'collection-layout',
      class CollectionLayout extends HTMLElement {
        /** @type {MutationObserver | undefined} */
        #observer;

        /**
         * Bootstraps controls relocation and wires MutationObserver to re-apply
         * after every Shopify section morph triggered by sort / filter changes.
         */
        connectedCallback() {
          this.#observer?.disconnect();
          this.#relocateControls();
          this.#observer = new MutationObserver(() => this.#relocateControls());
          this.#observer.observe(this.querySelector('.collection-sidebar') ?? this, { childList: true, subtree: true });
        }

        /** Disconnects the MutationObserver when the element is removed from the DOM. */
        disconnectedCallback() {
          this.#observer?.disconnect();
        }

        /**
         * Moves the desktop horizontal controls bar from `.collection-sidebar` to
         * `.collection-main` so it sits above the product grid. Pauses the observer
         * while mutating to prevent recursive callbacks; reconnects afterward.
         *
         * Targets `.facets--horizontal.facets-controls-wrapper` specifically rather than
         * the bare `.facets-controls-wrapper`: that bare class is shared by the mobile
         * controls bar (`.facets-mobile-wrapper.facets-controls-wrapper`), so a loose
         * selector lets the theme editor's repeated section morphs relocate the mobile
         * bar by mistake and `.remove()` the desktop bar — surfacing the mobile (single
         * column) controls at desktop widths. The mobile bar must stay where it is.
         */
        #relocateControls() {
          const sidebar = this.querySelector('.collection-sidebar');
          const main = this.querySelector('.collection-main');
          if (!sidebar || !main) return;

          const sidebarControls = sidebar.querySelector('.facets--horizontal.facets-controls-wrapper');
          if (!sidebarControls) return;

          // Pause the observer while we mutate to prevent recursive callbacks.
          // Guard: #observer is undefined on the first call (assigned after #relocateControls returns).
          this.#observer?.disconnect();

          // Keep the "Filters" heading in the sidebar: detach it from the controls
          // wrapper and insert it above the vertical facets panel.
          const filtersTitle = sidebarControls.querySelector('.facets--filters-title');
          const facetsPanel = sidebar.querySelector('.facets-block-wrapper--vertical');
          if (filtersTitle && facetsPanel) {
            facetsPanel.before(filtersTitle);
          }

          // Remove any stale copy morph left in main before moving the fresh one.
          const mainControls = main.querySelector('.facets--horizontal.facets-controls-wrapper');
          if (mainControls) mainControls.remove();
          main.prepend(sidebarControls);

          this.#observer?.observe(sidebar, { childList: true, subtree: true });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  if (!customElements.get('collection-layout')) {
    customElements.define(
      'collection-layout',
      class CollectionLayout extends HTMLElement {
        /** @type {MutationObserver | undefined} */
        #observer;

        /** Bootstraps controls relocation and wires the MutationObserver to re-apply after section morphs. */
        connectedCallback() {
          this.#observer?.disconnect();
          this.#relocateControls();
          this.#observer = new MutationObserver(() => this.#relocateControls());
          this.#observer.observe(this.querySelector('.collection-sidebar') ?? this, { childList: true, subtree: true });
        }

        /** Disconnects the MutationObserver when the element is removed from the DOM. */
        disconnectedCallback() {
          this.#observer?.disconnect();
        }

        /**
         * Moves the desktop horizontal controls bar from `.collection-sidebar` to
         * `.collection-main` so it sits above the product grid. Pauses the observer
         * while mutating to prevent recursive callbacks.
         *
         * Targets `.facets--horizontal.facets-controls-wrapper` specifically to avoid
         * accidentally relocating the mobile bar (`.facets-mobile-wrapper.facets-controls-wrapper`).
         */
        #relocateControls() {
          const sidebar = this.querySelector('.collection-sidebar');
          const main = this.querySelector('.collection-main');
          if (!sidebar || !main) return;

          const sidebarControls = sidebar.querySelector('.facets--horizontal.facets-controls-wrapper');
          if (!sidebarControls) return;

          this.#observer?.disconnect();

          const filtersTitle = sidebarControls.querySelector('.facets--filters-title');
          const facetsPanel = sidebar.querySelector('.facets-block-wrapper--vertical');
          if (filtersTitle && facetsPanel) {
            facetsPanel.before(filtersTitle);
          }

          const mainControls = main.querySelector('.facets--horizontal.facets-controls-wrapper');
          if (mainControls) mainControls.remove();
          main.prepend(sidebarControls);

          this.#observer?.observe(sidebar, { childList: true, subtree: true });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tier-benefits-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tier-benefits-tabs')) {
    customElements.define(
      'tier-benefits-tabs',
      class TierBenefitsTabs extends HTMLElement {
        /** Wires up click/keyboard tab-switching; the first tab is already active from Liquid-rendered markup. */
        connectedCallback() {
          this.addEventListener('click', (event) => {
            const tab = event.target.closest('[role="tab"]');
            if (tab) this.#activate(tab);
          });

          this.addEventListener('keydown', (event) => {
            const tabs = [...this.querySelectorAll('[role="tab"]')];
            const index = tabs.indexOf(event.target);
            if (index === -1) return;

            let next;
            if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
            if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
            if (event.key === 'Home') next = tabs[0];
            if (event.key === 'End') next = tabs[tabs.length - 1];
            if (!next) return;

            event.preventDefault();
            next.focus();
            this.#activate(next);
          });

          const firstTab = this.querySelector('[role="tab"]');
          if (firstTab) this.#activate(firstTab);
        }

        /**
         * Marks `tab` as the selected tab (aria-selected, roving tabindex) and shows
         * only its matching panel, hiding the rest.
         * @param {HTMLElement} tab
         */
        #activate(tab) {
          const targetPanelId = tab.getAttribute('aria-controls');

          this.querySelectorAll('[role="tab"]').forEach((t) => {
            const isActive = t === tab;
            t.setAttribute('aria-selected', isActive ? 'true' : 'false');
            t.setAttribute('tabindex', isActive ? '0' : '-1');
          });

          this.querySelectorAll('[role="tabpanel"]').forEach((panel) => {
            panel.toggleAttribute('hidden', panel.id !== targetPanelId);
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
